import { render } from "./ChangePassword.vue?vue&type=template&id=6f827fb6"
import script from "../js/change-password.js?vue&type=script&lang=js"
export * from "../js/change-password.js?vue&type=script&lang=js"

import "./ChangePassword.vue?vue&type=style&index=0&id=6f827fb6&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__